import { Service } from '@angular/core';
import { EnvironmentInformation } from './config.types';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export interface IConfigState {
  config?: EnvironmentInformation;
}

export interface IConfigAppState {
  config?: IConfigState;
}

export class SetConfig {
  static type = '[Config] SetConfig';

  constructor(public payload: EnvironmentInformation) {}
}

@State<IConfigState>({
  name: 'config',
  defaults: {}
})
@Service()
export class ConfigState {
  @Selector()
  static getConfigSelector(state: IConfigState) {
    return state.config;
  }
  @Action(SetConfig)
  setConfig({ getState, setState, patchState }: StateContext<IConfigState>, { payload }: SetConfig) {
    setState({ ...getState(), config: payload });
  }
}

export function getConfig(state: IConfigAppState): EnvironmentInformation {
  return state.config.config;
}
